<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import MainMenuDriverStatus from '@/presentation/components/mainmenu/MainMenuDriverStatus.vue';
import SideMenuItem from '@/presentation/components/mainmenu/SideMenuItem.vue';
import SideMenuTooltip from '@/presentation/components/mainmenu/SideMenuTooltip.vue';

const tooltipRefBottom = ref(null);
const router = useRouter();

const props = defineProps({
  collapsed: Boolean,
});

const items = [
  {
    name: 'ApiPage',
    translation: { key: 'global.api', params: {} },
    icon: 'robot',
    clickClosure: () => router.push({ name: 'ApiPage' }),
  },
  {
    name: 'Support',
    translation: { key: 'global.support', params: {} },
    icon: 'life-ring',
    clickClosure: () => router.push({ name: 'Support' }),
  },
];
</script>

<template>
  <div class="border-t-2 border-slate-600 rounded-xl">
    <ul>
      <MainMenuDriverStatus :collapsed="collapsed"/>
      <SideMenuItem
        v-for="item in items"
        :item="item"
        :collapsed="props.collapsed"
        @mouseenter="tooltipRefBottom?.onEnter($event, item)"
        @mouseleave="tooltipRefBottom?.onLeave()"/>
    </ul>
  </div>

  <SideMenuTooltip ref="tooltipRefBottom" :collapsed="props.collapsed"/>
</template>

<style scoped>

</style>